/**
 * Impersonation plugin.
 *
 * When impersonation is active, shift the entire .app down by the
 * banner height. This preserves all internal spacing so the page
 * looks exactly the same as it does without impersonation — just
 * moved 50px below the banner.
 */
const BANNER_HEIGHT = 48;

export default function ({ app }) {
  if (!process.browser) return;

  const raw = app.$cookies.get("impersonation_info");
  if (!raw) {
    document.body.classList.remove("impersonating");
    return;
  }

  document.body.classList.add("impersonating");

  if (!document.getElementById("impersonation-style")) {
    const style = document.createElement("style");
    style.id = "impersonation-style";
    style.textContent = `
      body.impersonating .app {
        padding-top: ${BANNER_HEIGHT}px;
      }
      body.impersonating .header {
        top: ${BANNER_HEIGHT}px !important;
      }
    `;
    document.head.appendChild(style);
  }
}
